<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
              :clearable="false" style="width: 200px;"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <el-button size="medium" type="primary" plain @click="exportExcel">导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs type="border-card" @tab-click="handleTabClick">
        <el-tab-pane label="团餐客户">
          <el-table :data="tableData" stripe border>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="NAME" label="名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="出库数量"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="供应商客户">
          <el-table :data="tableData" stripe border>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="NAME" label="名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="出库数量"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <!-- <el-row>
            <el-table :data="tableData" stripe border>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
                <el-table-column prop="NAME" label="名称"></el-table-column>
                <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
                <el-table-column prop="PRODUCT_COUNT" label="出库数量"></el-table-column>
            </el-table>
        </el-row> -->
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
          :total="totalCount" @current-change="handleCurrentChange"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { totalOutWarefun, exportTotalWarefun } from 'api/sendDoc';
import { getFormatDay } from '@/assets/common/common';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        date: getFormatDay(0, '-'),
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      currentOrderFlag: 0,
    };
  },
  methods: {
    queryTable(e) {
      const params = {
        SEND_DAY: this.searchForm.date,
        PAGESIZE: this.pageSize,
        PAGEINDEX: e,
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      totalOutWarefun(params).then((result) => {
        if (result[1]) {
          this.tableData = result[1].list;
          this.totalCount = result[0].TOTAL;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportExcel() {
      const params = {
        SEND_DAY: this.searchForm.date,
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      exportTotalWarefun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable(e - 1);
    },
    handleTabClick(tab, event) {
      this.currentOrderFlag = Number(tab.index);
      this.queryTable(0);
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sendDocument/totalOutWare.vue